var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-icon',{attrs:{"size":"200px"}},[_vm._v("mdi-bell-off-outline")]),_c('p',[_vm._v("No notifications available")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }